export default __webpack_public_path__ + "static/arrow-yellow-da66fb46f36864d5c367ea1f08bf202b.png";